/* global RdcTracking */

export const trackPhoneLead = function(propertyStatus, leadDelivery, leadPlacement, dataSourceType) {
  const linkName = `web:ldp:leads:phone:${propertyStatus}:${leadDelivery}`;
  const rentalDataSource = (propertyStatus === 'for_rent' ? dataSourceType : '');
  const props = { linkName, phoneLeads: linkName, leadPlacement: leadPlacement, rentalDataSource,};
  let evt;
  if (propertyStatus === 'for_sale') {
    if (['showcase', 'advantage_pro'].includes(leadDelivery)) {
      evt = "forSaleAdvantagePhoneLead";
    } else if (['cobroke', 'co_broke'].includes(leadDelivery)) {
      evt="forSaleCobrokePhoneLead";
    }
  } else if (propertyStatus === 'for_rent') {
    if (leadDelivery === 'basic') {
      evt = "rentalBasicPhoneLead";
    } else if (['showcase', 'advantage_pro'].includes(leadDelivery)) {
      evt = "rentalShowcasePhoneLead";
    }
  }
  RdcTracking.trackEvent(evt, props);
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/phone_leads.js